/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechGetTtsHistoryContent } from "../../funcs/llmSpeechGetTtsHistoryContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTextToSpeechHistoryContentRequest$inboundSchema,
};

export const tool$llmSpeechGetTtsHistoryContent: ToolDefinition<typeof args> = {
  name: "llm-speech-get-tts-history-content",
  description: `Retrieve text-to-speech audio

Returns the stored audio for a text-to-speech generation as a binary response.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechGetTtsHistoryContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
